export default __webpack_public_path__ + "static/media/Terms_and_conditions.b509f4ca.pdf";